<template>
	<div class="auth-login">
		<div class="auth-login__form form">
			<div class="form__header">Login</div>

			<div class="form__fields">
				<input class="form__field" :class="{ error }" type="text" v-model="email" />
				<input class="form__field" :class="{ error }" type="password" v-model="password" />
				<div v-if="error" class="form__error">{{ error }}</div>
			</div>

			<div class="form__buttons">
				<button class="form__button" @click="onLogin()">Войти</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex"

export default {
	name: "AuthLogin",
	data() {
		return {
			email: "",
			password: "",
			error: ""
		}
	},
	methods: {
		...mapActions("User", ["login"]),

		/**
		 * Залогиниться
		 */
		async onLogin() {
			this.error = ""

			try {
				await this.login({
					email: this.email,
					password: this.password
				})

				this.$emit("login-success")
			} catch (message) {
				this.error = message
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

.auth-login {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;

	&__form {
		padding: 20px 40px;
		width: 300px;
		background: white;
	}

	.form {
		display: flex;
		flex-direction: column;
		align-items: center;

		&__headers {
			font-size: 22px;
		}
		&__fields {
			display: flex;
			flex-direction: column;
			padding: 10px 0;
			width: 100%;
		}
		&__field {
			padding: 5px;
			margin-bottom: 10px;
			border: 1px solid $secondary-color;

			&.error {
				border-color: crimson;
			}
		}
		&__buttons {
			padding: 5px 10px;
		}
		&__button {
			@include button();
		}
		&__error {
			color: crimson;
		}
	}
}
</style>
